"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApptTimeMachine = void 0;
const xstate_1 = require("xstate");
const States_1 = require("../../../lib/constants/States");
const actions_apptTime_1 = __importStar(require("./actions.apptTime"));
const services_apptTime_1 = __importStar(require("./services.apptTime"));
const guards_apptTime_1 = __importStar(require("./guards.apptTime"));
const Events_1 = require("../../../lib/constants/Events");
const createApptTimeMachine = (context) => (0, xstate_1.createMachine)({
    id: `Machine__apptTime`,
    initial: States_1.newSearch,
    context: Object.assign(Object.assign({}, context), { query: Object.assign(Object.assign({}, context.appointmentQuery), { visibility: [context.visibility.schedulingVisibility], role: context.visibility.role }), isInitialDataLoadFromPreviousStep: Boolean(context.periodStart) !== true ? false : true }),
    on: {
        [Events_1.UPDATE_APPT_QUERY]: {
            actions: [actions_apptTime_1.updateQuery],
            target: [States_1.newSearch]
        },
        [Events_1.JUMP_TO_DATE]: {
            actions: [actions_apptTime_1.updateQuery, actions_apptTime_1.setJumpToDate, actions_apptTime_1.setParentJumpToDate],
            target: States_1.newSearch
        },
        [Events_1.GO_BACK]: {
            actions: actions_apptTime_1.sendParentBack,
            target: States_1.exit
        }
    },
    states: {
        [States_1.newSearch]: {
            id: 'newSearch',
            initial: States_1.fetchAvailableSlots,
            on: {
                [Events_1.SELECT_APPOINTMENT]: [
                    {
                        actions: [actions_apptTime_1.selectAppointmentSlots, actions_apptTime_1.sendParentNext],
                        target: States_1.done
                    }
                ]
            },
            states: {
                [States_1.fetchAvailableSlots]: {
                    invoke: {
                        id: 'getSlotsList.newSearch',
                        src: services_apptTime_1.getSlotsList,
                        onDone: [
                            {
                                cond: guards_apptTime_1.hasNoResults,
                                actions: actions_apptTime_1.setEmptyAppointmentSlots,
                                target: States_1.noResults
                            },
                            { actions: actions_apptTime_1.setAppointmentSlots, target: States_1.success }
                        ],
                        onError: States_1.failedFetchingslots
                    }
                },
                [States_1.failedFetchingslots]: {},
                [States_1.noResults]: {
                    on: {
                        [Events_1.SET_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.updateFilterBy, actions_apptTime_1.updateParentFilterBy]
                        },
                        [Events_1.CLEAR_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.clearFilters, actions_apptTime_1.clearParentFilters]
                        }
                    }
                },
                [States_1.success]: {
                    on: {
                        [Events_1.LOAD_MORE]: {
                            target: States_1.done,
                            actions: actions_apptTime_1.updateQuery
                        },
                        [Events_1.SET_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.updateFilterBy, actions_apptTime_1.updateParentFilterBy]
                        },
                        [Events_1.CLEAR_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.clearFilters, actions_apptTime_1.clearParentFilters]
                        }
                    }
                },
                [States_1.done]: {
                    type: 'final'
                }
            },
            onDone: [{ target: States_1.nextSearch }]
        },
        [States_1.nextSearch]: {
            initial: States_1.fetchAvailableSlots,
            on: {
                [Events_1.SELECT_APPOINTMENT]: [
                    {
                        actions: [actions_apptTime_1.selectAppointmentSlots, actions_apptTime_1.sendParentNext],
                        target: States_1.done
                    }
                ]
            },
            states: {
                [States_1.success]: {
                    on: {
                        [Events_1.LOAD_MORE]: {
                            target: States_1.fetchAvailableSlots,
                            actions: actions_apptTime_1.updateQuery
                        },
                        [Events_1.SET_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.updateFilterBy, actions_apptTime_1.updateParentFilterBy]
                        },
                        [Events_1.CLEAR_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.clearFilters, actions_apptTime_1.clearParentFilters]
                        }
                    }
                },
                // NOTE:
                // we're in a `noResults` from the `nextSearch` state
                // which means we're on page 2 or greater of the list.
                // So there are appointments already loaded on the page
                [States_1.noResults]: {
                    on: {
                        [Events_1.SET_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.updateFilterBy, actions_apptTime_1.updateParentFilterBy]
                        },
                        [Events_1.CLEAR_TOOLBAR_FILTERS]: {
                            actions: [actions_apptTime_1.clearFilters, actions_apptTime_1.clearParentFilters]
                        }
                    }
                },
                [States_1.fetchAvailableSlots]: {
                    invoke: {
                        id: 'getSlotsList.nextSearch',
                        src: services_apptTime_1.getSlotsList,
                        onDone: [
                            {
                                cond: guards_apptTime_1.hasNoResults,
                                target: States_1.noResults
                            },
                            { actions: actions_apptTime_1.addAppointmentSlots, target: States_1.success }
                        ],
                        onError: States_1.noResults
                    }
                }
            }
        },
        [States_1.done]: {
            type: 'final',
            entry: [actions_apptTime_1.sendParentNext]
        },
        [States_1.exit]: {
            type: 'final'
        }
    }
}, {
    guards: guards_apptTime_1.default,
    services: services_apptTime_1.default,
    actions: actions_apptTime_1.default
});
exports.createApptTimeMachine = createApptTimeMachine;
//# sourceMappingURL=apptTIme.js.map